import React, {useEffect, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core/styles';

import {useLocation, useParams} from "react-router-dom";
import {redirection} from "./utils";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },
    },
}));

const MIN_AMOUNT = 100;
const PAYMENT_CODE_LEN = 6;
const MIN_PHONE_LEN = 8;

export default function WebPaymentForm() {
    const classes = useStyles();
    const queries = useQuery();
    const [phoneNumber, setPhoneNumber] = useState("");
    const [paymentCode, setPaymentCode] = useState("");
    const [currency, setCurrency] = useState("XOF");
    const [lang, setLang] = useState("fr");
    const [amount, setAmount] = useState('');
    const [showAmount, setShowAmount] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [succeeded, setSucceeded] = useState(false);
    const [merchantKey, setMerchantKey] = useState(queries.get("merchant_key"));
    const [orderId, setOrderId] = useState(queries.get("order_id"));
    const [clientName, setClientName] = useState('Djamma Orange Web Payment');
    const [message, setMessage] = useState('');

    const name = queries.get('name');
    const email = queries.get('email');
    const phone = queries.get('phone');
    const redirect = queries.get('redirect');

    document.title = clientName

    const params = useParams();
    const authorization = params.token;

    const createPayment = async () => {
        // Create PaymentIntent as soon as the page loads
        let body = {
            phoneNumber,
            paymentCode,
            amount,
            currency,
            lang,
            metadata: queries
        };
        if (merchantKey) {
            body['merchant_key'] = merchantKey;
        }
        if (orderId) {
            body['order_id'] = orderId;
        }
        return fetch("/api/orange/payment", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authorization}`
            },
            body: JSON.stringify(body)
        })
            .then(res => {
                return res.json();
            });
    };

    const retrieveClientInformation = async () => {
        if (authorization && authorization.length > 0) {
            try {
                let data = await fetch(`/api/orange/client`, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${authorization}`
                    }
                }).then(res => res.json());
                console.log('data', data);
                if (data.code && data.code / 100 !== 2) {
                    setError(data.message);
                } else {
                    setClientName(data.name);
                }
            } catch (e) {
                console.log(e);
                /*if (data.code && data.code / 100 !== 2) {
                    setError(data);
                } else {
                    setClientName(data.name);
                }*/
            }
        }
    }

    const retrieveInformation = () => {
        if (authorization && authorization.length > 0) {
            setShowAmount(false);
            console.log('orderId', orderId);
            if (orderId && orderId.length > 0) {
                setShowAmount(false);
                fetch(`/api/orange/complete?orderId=${orderId}`, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${authorization}`
                    }
                })
                    .then(res => {
                        if (res.status !== 200) {
                            return Promise.reject(res)
                        }
                        return res.json();
                    })
                    .then(data => {
                        console.log('data', data);
                        setAmount(data.amount || '');
                        setLang(data.lang)
                        setCurrency(data.currency);
                        setSucceeded(data.success);
                        setMerchantKey(data.merchant_key)
                        setPhoneNumber(data.phoneNumber || '')
                        setPaymentCode(data.paymentCode || '')
                    })
                    .catch(error => {
                        console.log('error', error);
                        setShowAmount(true);
                    });
            } else {
                setShowAmount(true);
            }
        }
        retrieveClientInformation();
    }

    useEffect(retrieveInformation, []);

    const handleSubmit = (ev) => {
        ev.preventDefault();
        setProcessing(true);
        createPayment().then(res => {
            console.log('res', res);
            if (res.code) {
                setError(`Payment failed ${res.message || res.description}`);
                setProcessing(false);
            } else {
                setError(null);
                setProcessing(false);
                setSucceeded(true);
                let entity = res.entity;
                if (!Boolean(entity)) {
                    entity = res;
                }
                setSucceeded(entity.success || entity.status === 'SUCCESS');
                if (entity.success || entity.status === 'SUCCESS') {
                    setMessage("Payment has been proceeded successfully");
                } else {
                    setMessage("Payment has not completed please follow this link to complete : " + entity.payment_url);
                }
                setMerchantKey(entity.merchant_key)
                setOrderId(entity.order_id);
                redirection(redirect);
            }
        }).catch(error => {
            console.log('error', error);
            setError(`Payment failed ${error.message}`);
            setProcessing(false);
        });
    }
    return (
        <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
            <h1>{clientName}</h1>
            {orderId && <h2>Order Id : {orderId}</h2>}
            <h3>{name} {email} {phone}</h3>
            <TextField fullWidth
                       id="standard-error"
                       label="Phone Number"
                       value={phoneNumber}
                       disabled={succeeded}
                       placeholder={"7701100250"}
                       onChange={e => {
                           setPhoneNumber(e.target.value);
                       }}
            />
            <TextField fullWidth
                       id="standard-error"
                       label="Payment Code"
                       value={paymentCode}
                       disabled={succeeded}
                       placeholder={"123456"}
                       helperText={"#144#77# for payment code."}
                       onChange={e => {
                           setPaymentCode(e.target.value)
                       }}
            />
            <TextField fullWidth
                       id="standard-error"
                       label="Amount"
                       type={"number"}
                       value={amount}
                       placeholder={"5000"}
                       disabled={!showAmount || succeeded}
                       onChange={e => {
                           setAmount(e.target.value * 1)
                       }}
            />

            <button
                disabled={processing || succeeded || ((phoneNumber || '').length < MIN_PHONE_LEN
                    || (paymentCode || '').length < PAYMENT_CODE_LEN
                    || amount * 1 < MIN_AMOUNT)}
                id="submit"
            >
                <span id="button-text">
                  {processing ? (
                      <div className="spinner" id="spinner"></div>
                  ) : (
                      "Orange Web Payment"
                  )}
                </span>
            </button>
            {/* Show any error that happens when processing the payment */}
            {error && (
                <div className="card-error" role="alert">
                    {error}
                </div>
            )}
            {/* Show a success message upon completion */}
            <p className={Boolean(message) ? "result-message" : "result-message hidden"}>
                {message}
            </p>
        </form>
    );
}